// extracted by mini-css-extract-plugin
module.exports = {"administrationTabContent":"_2e42Y"};